export const ONEPLAYERUI_ERRORS = {
  NO_ERROR_CODE: 0,
  BAD_HTTP_STATUS: 1001,
  INVALID_XML: 2005,
  MEDIA_SOURCE_OPERATION_FAILED: 3014,
  VIDEO_ERROR: 3016,
  UNPLAYABLE_PERIOD: 4011,
  MANIFEST_PARSING_FAILURE: 4013,
  DATA_UPDATE_FAILURE: 4015,
  CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
  REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
  FAILED_TO_CREATE_CDM: 6002,
  INVALID_SERVER_CERTIFICATE: 6004,
  FAILED_TO_CREATE_SESSION: 6005,
  FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
  LICENSE_REQUEST_FAILED: 6007,
  LICENSE_RESPONSE_REJECTED: 6008,
  STATUS_CHANGED_EXPIRED: 6011,
  NO_LICENSE_SERVER_GIVEN: 6012,
  STATUS_CHANGED_OUTPUT_RESTRICTED: 6018,
  INTERNAL_ERROR: 8000,
  API_DEPRECATED: 9000,
  UNMAPPED_ERROR: 10000,
  PLAYER_TOO_MANY_SESSIONS: 2382,
  PLAYER_TOO_MANY_TERMINALS: 2383
}

export const PLAYER_ERROR = {
  INCOMPATIBLE_CONFIGURATION: [
    ONEPLAYERUI_ERRORS.CONTENT_UNSUPPORTED_BY_BROWSER,
    ONEPLAYERUI_ERRORS.MEDIA_SOURCE_OPERATION_FAILED,
    ONEPLAYERUI_ERRORS.REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE,
    ONEPLAYERUI_ERRORS.FAILED_TO_CREATE_CDM
  ],
  STREAM_ISSUE: [
    ONEPLAYERUI_ERRORS.BAD_HTTP_STATUS,
    ONEPLAYERUI_ERRORS.INVALID_XML,
    ONEPLAYERUI_ERRORS.VIDEO_ERROR,
    ONEPLAYERUI_ERRORS.UNPLAYABLE_PERIOD,
    ONEPLAYERUI_ERRORS.MANIFEST_PARSING_FAILURE,
    ONEPLAYERUI_ERRORS.DATA_UPDATE_FAILURE,
    ONEPLAYERUI_ERRORS.FAILED_TO_GENERATE_LICENSE_REQUEST,
    ONEPLAYERUI_ERRORS.NO_LICENSE_SERVER_GIVEN,
    ONEPLAYERUI_ERRORS.LICENSE_REQUEST_FAILED,
    ONEPLAYERUI_ERRORS.LICENSE_RESPONSE_REJECTED,
    ONEPLAYERUI_ERRORS.STATUS_CHANGED_EXPIRED
  ],
  MEDIA_RESTRICTED: [
    ONEPLAYERUI_ERRORS.STATUS_CHANGED_OUTPUT_RESTRICTED
  ],
  PLAYER_RESTRICTED: [
    ONEPLAYERUI_ERRORS.PLAYER_TOO_MANY_SESSIONS,
    ONEPLAYERUI_ERRORS.PLAYER_TOO_MANY_TERMINALS
  ],
  OTHERS: [
    ONEPLAYERUI_ERRORS.NO_ERROR_CODE,
    ONEPLAYERUI_ERRORS.INVALID_SERVER_CERTIFICATE,
    ONEPLAYERUI_ERRORS.FAILED_TO_CREATE_SESSION,
    ONEPLAYERUI_ERRORS.INTERNAL_ERROR,
    ONEPLAYERUI_ERRORS.API_DEPRECATED,
    ONEPLAYERUI_ERRORS.UNMAPPED_ERROR
  ],
  // Errors that can trigger an autoreload of the player
  AUTORELOAD_TRIGGER_ERRORS: [
    ONEPLAYERUI_ERRORS.BAD_HTTP_STATUS
  ]
}
